import React from 'react';
import "./NavigationDots.css"

const NavigationDots = ({ active }) => {
  return (
    <div className='app__navigation'>
      {['home', 'about', 'work', 'skills', 'testimonial', 'contact'].map((item, index) => (
        <a
          href={`#${item}`}
          key={item + index}
          className="app__navigation-dot"
          style={active === item ? { backgroundColor: '#313BAC' } : {}}
        >
          {/* Add visually hidden label for accessibility */}
          <span className="visually-hidden">{`${item} section`}</span>
        </a>
      ))}
    </div>
  );
};

export default NavigationDots;
